export default __webpack_public_path__ + "static/media/stock.b32fa6c1.svg";